import { relations } from 'drizzle-orm/relations';
import * as schema from './schema';

export const eventRelation = relations(schema.event, ({ one }) => ({
  promoter: one(schema.member, {
    fields: [schema.event.promoterId],
    references: [schema.member.memberId],
  }),
}));

export const itemRelation = relations(schema.item, ({ many, one }) => ({
  itemI18Ns: many(schema.itemI18N),
  itemPictures: many(schema.itemPicture),
  itemListingFirstLastHistory: one(schema.itemListingFirstLastHistory, {
    fields: [schema.item.itemId],
    references: [schema.itemListingFirstLastHistory.itemId],
  }),
  likes: many(schema.likeness),
}));

export const itemI18NRelation = relations(schema.itemI18N, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemI18N.itemId],
    references: [schema.item.itemId],
  }),
}));

export const itemPictureRelation = relations(schema.itemPicture, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemPicture.itemId],
    references: [schema.item.itemId],
  }),
}));

export const likenssRelation = relations(schema.likeness, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.likeness.linkId],
    references: [schema.item.itemId],
  }),
  followee: one(schema.member, {
    fields: [schema.likeness.linkId],
    references: [schema.member.memberId],
    relationName: 'followee',
  }),
  member: one(schema.member, {
    fields: [schema.likeness.memberId],
    references: [schema.member.memberId],
    relationName: 'member',
  }),
}));

export const memberRelation = relations(schema.member, ({ many, one }) => ({
  events: many(schema.event),
  memberI18Ns: many(schema.memberI18N),
  memberPicture: one(schema.memberPicture, {
    fields: [schema.member.memberId],
    references: [schema.memberPicture.memberId],
  }),
  follows: many(schema.likeness),
}));

export const memberI18NRelation = relations(schema.memberI18N, ({ one }) => ({
  member: one(schema.member, {
    fields: [schema.memberI18N.memberId],
    references: [schema.member.memberId],
  }),
}));

export const memberPictureRelation = relations(schema.memberPicture, ({ one }) => ({
  member: one(schema.member, {
    fields: [schema.memberPicture.memberId],
    references: [schema.member.memberId],
  }),
}));
